/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as Account_nuxRouteImport } from './routes/account_nux'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvitationsAcceptRouteImport } from './routes/invitations/accept'
import { Route as LayoutWebhooksRouteImport } from './routes/_layout/webhooks'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutMembersRouteImport } from './routes/_layout/members'
import { Route as LayoutBillingRouteImport } from './routes/_layout/billing'
import { Route as LayoutApiKeysRouteImport } from './routes/_layout/api-keys'
import { Route as LayoutAnalyticsRouteImport } from './routes/_layout/analytics'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const Account_nuxRoute = Account_nuxRouteImport.update({
  id: '/account_nux',
  path: '/account_nux',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutWebhooksRoute = LayoutWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMembersRoute = LayoutMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutBillingRoute = LayoutBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutApiKeysRoute = LayoutApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAnalyticsRoute = LayoutAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => LayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account_nux': typeof Account_nuxRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/analytics': typeof LayoutAnalyticsRoute
  '/api-keys': typeof LayoutApiKeysRoute
  '/billing': typeof LayoutBillingRoute
  '/members': typeof LayoutMembersRoute
  '/settings': typeof LayoutSettingsRoute
  '/webhooks': typeof LayoutWebhooksRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account_nux': typeof Account_nuxRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/analytics': typeof LayoutAnalyticsRoute
  '/api-keys': typeof LayoutApiKeysRoute
  '/billing': typeof LayoutBillingRoute
  '/members': typeof LayoutMembersRoute
  '/settings': typeof LayoutSettingsRoute
  '/webhooks': typeof LayoutWebhooksRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/account_nux': typeof Account_nuxRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/_layout/analytics': typeof LayoutAnalyticsRoute
  '/_layout/api-keys': typeof LayoutApiKeysRoute
  '/_layout/billing': typeof LayoutBillingRoute
  '/_layout/members': typeof LayoutMembersRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/webhooks': typeof LayoutWebhooksRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account_nux'
    | '/onboarding'
    | '/sign-in'
    | '/analytics'
    | '/api-keys'
    | '/billing'
    | '/members'
    | '/settings'
    | '/webhooks'
    | '/invitations/accept'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account_nux'
    | '/onboarding'
    | '/sign-in'
    | '/analytics'
    | '/api-keys'
    | '/billing'
    | '/members'
    | '/settings'
    | '/webhooks'
    | '/invitations/accept'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/account_nux'
    | '/onboarding'
    | '/sign-in'
    | '/_layout/analytics'
    | '/_layout/api-keys'
    | '/_layout/billing'
    | '/_layout/members'
    | '/_layout/settings'
    | '/_layout/webhooks'
    | '/invitations/accept'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  Account_nuxRoute: typeof Account_nuxRoute
  OnboardingRoute: typeof OnboardingRoute
  SignInRoute: typeof SignInRoute
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account_nux': {
      id: '/account_nux'
      path: '/account_nux'
      fullPath: '/account_nux'
      preLoaderRoute: typeof Account_nuxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/accept': {
      id: '/invitations/accept'
      path: '/invitations/accept'
      fullPath: '/invitations/accept'
      preLoaderRoute: typeof InvitationsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/webhooks': {
      id: '/_layout/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof LayoutWebhooksRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/members': {
      id: '/_layout/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof LayoutMembersRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/billing': {
      id: '/_layout/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof LayoutBillingRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/api-keys': {
      id: '/_layout/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof LayoutApiKeysRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/analytics': {
      id: '/_layout/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof LayoutAnalyticsRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutAnalyticsRoute: typeof LayoutAnalyticsRoute
  LayoutApiKeysRoute: typeof LayoutApiKeysRoute
  LayoutBillingRoute: typeof LayoutBillingRoute
  LayoutMembersRoute: typeof LayoutMembersRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutWebhooksRoute: typeof LayoutWebhooksRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAnalyticsRoute: LayoutAnalyticsRoute,
  LayoutApiKeysRoute: LayoutApiKeysRoute,
  LayoutBillingRoute: LayoutBillingRoute,
  LayoutMembersRoute: LayoutMembersRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutWebhooksRoute: LayoutWebhooksRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  Account_nuxRoute: Account_nuxRoute,
  OnboardingRoute: OnboardingRoute,
  SignInRoute: SignInRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
